import React, { Component } from 'react';
import { Table, Space, Button, Input } from 'antd';
import PropTypes from 'prop-types';
import { SearchOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

class SearchTable extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedRowKeys: props.initialSelection === undefined ? [] : props.initialSelection,
            searchText: '',
            searchedColumn: '',
          };

        this.searchColumns = this.props.columns.map(function(item) {
            if (item["search"])
            {
                return {...item, ...this.getColumnSearchProps(item.dataIndex, item.title)};
            }
            else
            {
                return item;
            }
          }, this);
        }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                this.searchInput = node;
              }}
              placeholder={`Search`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                <FormattedMessage id="Search"/>
              </Button>
              <Button onClick={() => this.handleReset(clearFilters, confirm)} size="small" style={{ width: 90 }}>
                <FormattedMessage id="Reset"/>
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({ closeDropdown: false });
                  this.setState({
                    searchText: selectedKeys[0],
                    searchedColumn: dataIndex,
                  });
                }}
              >
                <FormattedMessage id="Filter"/>
              </Button>
            </Space>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) => {
          return record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : false;
        },
        onFilterDropdownOpenChange: visible => {
          if (visible) {
            setTimeout(() => this.searchInput.select(), 100);
          }
        },
      });
    
      handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
      handleReset = (clearFilters, confirm) => {
        clearFilters();
        confirm();
        this.setState({ searchText: '' });
      };
    
      onSelectChange (selectedRowKeys)  {
          if (this.props.onSelectChange !== undefined)
          {
              this.props.onSelectChange(selectedRowKeys);
          }

          this.setState({ selectedRowKeys });
      };

    render() {

        var localRowSelection = null;
        
        if (this.props.type !== undefined)
        {
            localRowSelection = {
                type: this.props.type,
                selectedRowKeys: this.state.selectedRowKeys,
                onChange: (selectedRowKeys) => {this.onSelectChange(selectedRowKeys)},
            };
        }
  
        return (
            <div>
                <Table 
                columns={this.searchColumns} 
                dataSource={this.props.dataSource}
                rowSelection = {localRowSelection}
                {...this.props.layout}             
                />
            </div>
        );
      }
}

SearchTable.propTypes = {
    dataSource: PropTypes.array,
    columns: PropTypes.array.isRequired
    };

export default SearchTable;